import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import moment from 'moment'
import { connect } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
// useNavigate
import { useForm, Controller } from 'react-hook-form'
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import { Circles } from 'react-loader-spinner'
import { getCitationDetails, postBeforePayment, postCreateAppeal, postVoidAppeal } from '../../redux/actions/citationAction'
import { useState } from 'react'
const phoneMaskGenerator = createDefaultMaskGenerator('(999) 999-9999')
const cardnumbermask = createDefaultMaskGenerator('9999 9999 9999 9999')
import 'react-toastify/dist/ReactToastify.css'
import { Form } from 'react-bootstrap'
import { checkStartCitationWarning, encryptionHandler, formatYearMonthExpiry, getFormattedAmountNumber, handleKeyPressRestrictLeadingTrailingSpace, isPermissionExist, isVoidButton, nullAndUndefinedCheck, restrictInputValues, restrictSpecialChar, showPaymentCardDetials, validExpiryDate, loggedInUserData } from '../../utils/helper'
import AppealModal from '../../components/global/AppealModal'
import corssImg from '../../assets/img/citation-icon.png'
import CardConnectTokenizer from '../../components/walletButtons/CardTokenizer'
import { useCaptchaService } from '../../services/captchaService'
const expirymask = createDefaultMaskGenerator('99/99')

function Main(props) {
  // const { register, handleSubmit, formState: { errors }, control, getValues } = useForm({ shouldFocusError: false })
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    control,
    getValues,
    trigger,
    setValue
  } = useForm({
    shouldFocusError: false,
    mode: 'onChange'
  })
  const { control: controlForm2, handleSubmit: handleSubmitForm2, formState: { errors: errorsForm2 }, setError: setErrorForm2, reset: resetForm2 } = useForm()

  const [citationData, setCitationData] = useState(EMPTY_ARRAY)
  const [facilityData, setFacilityData] = useState(EMPTY_OBJECT)
  const [ipgSession, setIpgSession] = useState('')
  // const [url, setUrl] = useState('')
  const [guid, setGuid] = useState(EMPTY_OBJECT)
  const [error, setError] = useState('')
  const [isSubmitted, setIsSubmitted] = useState(false)

  const { formRef, formRef2 } = useRef()

  let { citation } = useParams()

  const { loader, dispatch, notify } = props
  const navigate = useNavigate()
  const partner = window.location.toString().split('/')[3]
  const captchaService = useCaptchaService()


  // for the demo citation flow 
  const [showAppealModal, setShowAppealModal] = useState(false)
  const [showVoidModal, setShowVoidModal] = useState(false)
  const [isAppealRequest, setIsAppealRequest] = useState(false)
  const [cardExpiry, setCardExpiry] = useState('')
  // const [cardExpiryMessage, setCardExpiryMessage] = useState('')

  // for appeal specific
  const [appealAppliedData, setAppealData] = useState(EMPTY_ARRAY)
  const [appealDataForTable, setAppealDataForTable] = useState(EMPTY_ARRAY)
  const [showButtionForAppealVoid, setShowAppealVoidButton] = useState(true)
  // end

  // EOS-973
  const tokenRef = useRef(null)
  const [cardToken, setCardToken] = useState('')
  const [iframeErrorMsg, setIframeErrorMsg] = useState('')
  // EOS-973

  const loggedUserEmail = loggedInUserData()?.user?.email || ''
  const handleShowAppealModal = () => {
    setShowAppealModal(!showAppealModal)
    resetForm2({ remarks: '', email: loggedUserEmail })
  }
  const handleVoidModal = () => {
    setShowVoidModal(!showVoidModal)
    resetForm2()
  }


  useEffect(() => {
    if (citation && citation !== undefined) {
      handleGetForData()
    }
  }, [EMPTY_ARRAY])

  useEffect(() => {
    const timer = setTimeout(() => {
      const fields = [
        'email',
        'name_on_card',
        'security_code',
        'zip_code'
      ]

      fields.forEach((fieldName) => {
        const input = document.querySelector(`[name="${fieldName}"]`)

        if (input?.value) {
          setValue(fieldName, input.value, {
            shouldValidate: true,
            shouldDirty: true,
          })
        }
      })

      trigger()
    }, 800)

    return () => clearTimeout(timer)
  }, [setValue, trigger])

  const handleGetForData = async () => {
    const payload = { 'citation_number': citation }

    try {
      const recaptchaToken = await captchaService.execute('checkout')
      payload.recaptcha_token = recaptchaToken
    } catch (captchaError) {
      setIsSubmitted(false)
      notify('error', captchaError?.message || 'reCAPTCHA verification could not be completed.')
      return
    }

    dispatch(getCitationDetails(payload)).then((res) => {
      if (res?.status === 201) {
        // FOR DYANMIC DATA RENDER IN THE GET LIST
        let data = [{ 'headerName': (checkStartCitationWarning(citation) == 'WA') ? 'Warning No' : 'Citation No', 'val': citation }, { 'headerName': 'Issue Date', 'val': `${moment(res?.data?.ticket?.created_at).format('MM/DD/YY - hh:mm A')}` }, { 'headerName': 'License No.', 'val': res?.data?.ticket?.license_plate }, { 'headerName': 'Violation', 'val': (checkStartCitationWarning(citation) == 'WA') ? res?.data?.ticket?.warning_infraction?.[0]?.infraction_name : res?.data?.ticket?.ticket_citation_infraction?.[0]?.infraction_name }, { 'headerName': 'Penalty Fee', val: getFormattedAmountNumber(res?.data?.ticket?.penalty_fee), id: 0 }]
        // Object.entries(res.data)?.filter((item) => console.log('item', item))
        // (item?.[0] !== 'facility' && item?.[0] !== 'tax_rate' && item?.[0] !== 'rate' && item?.[0] !== 'price' && item?.[0] !== 'processing_fee' && item?.[0] !== 'ticket' && item?.[0] !== 'no_of_hrs') ? data.push({ 'headerName': trimContant(item), 'val': item?.[1], id: 0 }) : (item?.[0] === 'rate' ?? item?.[0] === 'price') ?
        //   data.push({ 'headerName': 'Parking Amount', 'val': item?.[1], id: 0 }) : (item?.[0] === 'processing_fee') ? data.push({ 'headerName': 'Citation Processing Fee', 'val': item?.[1], id: 0 }) : (item?.[0] === 'no_of_hrs') ? data.push({ 'headerName': 'No of Hours', 'val': item?.[1] }) : '')
        // 
        if (res?.data?.citation_processing_fee) {
          data?.push({ 'headerName': 'Citation Processing Fee', 'val': `$${getFormattedAmountNumber(res?.data?.citation_processing_fee)}` })
        }

        if (res?.data?.tax_fee) {
          data?.push({ 'headerName': 'Citation Tax Fee', 'val': `$${getFormattedAmountNumber(res?.data?.tax_fee)}` })
        }

        if (Number(res?.data?.ticket?.discount_amount) > 0) {
          data?.push({ 'headerName': 'Settled Amount', 'val': `$${getFormattedAmountNumber(res?.data?.ticket?.discount_amount)}` })
        }

        if (res?.data?.ticket?.is_closed == '1' || res?.data?.ticket?.is_reopen == '1') {
          data?.push({ 'headerName': 'Citation Status', val: res?.data?.ticket?.is_closed == '1' ? 'Closed' : res?.data?.ticket?.is_reopen == '1' ? 'Reopen' : '' })
        }

        if (nullAndUndefinedCheck(res?.data?.ticket?.anet_transaction_id)) {
          data?.push({ 'headerName': 'Payment Status', val: 'Paid' })
        }

        if (parseFloat(res?.data?.ticket?.grand_total) > 0 && nullAndUndefinedCheck(res?.data?.ticket?.anet_transaction_id)) {
          data?.push({ 'headerName': 'Paid Amount', val: res?.data?.ticket?.grand_total, id: 0 })
        }

        if (nullAndUndefinedCheck(res?.data?.ticket?.remaining_amount) > 0 && !nullAndUndefinedCheck(res?.data?.ticket?.anet_transaction_id)) {
          data?.push({ 'headerName': 'Amount to Pay', val: getFormattedAmountNumber(res?.data?.payable_amount), id: 0 })
        }

        if ((checkStartCitationWarning(citation) == 'WA')) {
          data = data.filter((item) => item?.headerName !== 'Penalty Fee')
          setCitationData(data)
        } else {
          setCitationData(data)
        }

        // for the appeal specific
        // FOR DYANMIC DATA RENDER IN THE GET LIST appeal table
        const existingAppealData = (res?.data?.ticket?.appeal?.length > 0) ? res?.data?.ticket?.appeal : []

        let appealTableData = existingAppealData?.map((appeal, index) => {

          const appealRow = { appeal: (existingAppealData?.length == 1 && index == 0) ? 'Appeal' : (existingAppealData?.length == 2 && index == 0) ? 'Previous Appeal' : 'Current Appeal', data: [] }

          // status

          if (nullAndUndefinedCheck(appeal?.appeal_message)) {
            appealRow.data.push({ 'headerName': 'Appeal Status', 'val': appeal.appeal_message?.toUpperCase(), isHighlight: true })
          }

          // Applied on

          if (nullAndUndefinedCheck(appeal?.created_at)) {
            appealRow.data.push({ 'headerName': 'Applied on', 'val': moment(appeal?.created_at).format('MM/DD/YY - hh:mm A') })
          }

          // avoid
          if (nullAndUndefinedCheck(res?.data?.ticket?.avoid_comment)) {
            appealRow.data.push({ 'headerName': 'Void Remark', 'val': res?.data?.ticket.avoid_comment?.toUpperCase() })
          }

          if (res?.data?.ticket?.is_avoid === '1') {
            appealRow.data.push({ 'headerName': 'Void Status', val: 'Voided', isHighlight: true })
          }
          // avoid end

          // user remark 
          if (nullAndUndefinedCheck(appeal?.user_remark)) {
            appealRow.data.push({ 'headerName': 'User Remark', 'val': appeal.user_remark?.toUpperCase() })
          }
          // Admin remark
          if (nullAndUndefinedCheck(appeal?.admin_remark)) {
            appealRow.data.push({ 'headerName': 'Admin Remark', 'val': appeal.admin_remark?.toUpperCase() })
          }
          // 
          if (nullAndUndefinedCheck(appeal?.updated_at) && appeal?.appeal_status != '1') {
            appealRow.data.push({ 'headerName': (appeal?.appeal_message == 'Rejected') ? 'Rejected on' : 'Approved on', 'val': moment(appeal?.updated_at).format('MM/DD/YY - hh:mm A') })
          }

          if (nullAndUndefinedCheck(appeal?.discount_amount) > 0) {
            appealRow.data.push({ 'headerName': 'Approved Amount', 'val': getFormattedAmountNumber(appeal?.discount_amount) || '', id: 0 })
          }
          return appealRow
        })

        setAppealDataForTable(appealTableData)
        setAppealData(existingAppealData)
        // end

        setFacilityData(res?.data)
        // setUrl(res?.data?.api_url)
        setGuid(res?.data?.guid)
        setIpgSession(res?.data?.ipgSession)

        // for the citation history
        const previousHistory = {
          'Citation History': res?.data?.citation_history,
          'Warning History': res?.data?.warning_history,
        }
        localStorage.setItem('previousHistory', JSON.stringify(previousHistory))
        localStorage.setItem('citation', citation)

        // to hide and show button 
        if ((existingAppealData?.length === 1 && existingAppealData[0]?.appeal_status == '4') || (existingAppealData?.length === 2)) {
          setShowAppealVoidButton(false)
        }
      } else {
        setCitationData(EMPTY_ARRAY)
        setFacilityData({})
        setError(res?.errors?.message)
        notify('error', res?.errors?.message)
      }
    }).catch((err) => {
      setError(err)
      console.log(err)
    })
  }
  const onSubmit = async () => {
    const formValues = getValues()
    // const form = formRef.current
    if (Object.values(formValues)?.length > 0 && ((formValues?.card_pan && formValues?.name_on_card && (formValues?.expiry && formValues?.expiry != '') && formValues?.security_code) || (cardToken && cardToken?.token && (!iframeErrorMsg || iframeErrorMsg == '')))) {
      // const card_expiration_date = formValues?.card_date_expiry_month + formValues?.card_date_expiry_year
      setIsSubmitted(true)
      let nonce = null
      if (facilityData?.facility_payment_details?.facility_payment_type_id == '3' && cardToken && cardToken.token) {
        // For Fiserv, use cardToken to create payment data
        let card = {
          name_on_card: formValues?.name_on_card || '',
          card_number: cardToken?.token || '',
          expiration_date: formatYearMonthExpiry(cardToken?.expiry),
          security_code: '',
        }
        if (cardToken?.zip_code) {
          card.zip_code = cardToken?.zip_code
        }
        nonce = encryptionHandler(card)

      } else {
        let cardData = {
          name_on_card: formValues?.name_on_card,
          card_number: formValues?.card_pan ? formValues?.card_pan : '',
          expiration_date: formValues?.expiry ? formValues?.expiry : '',
          security_code: formValues?.security_code,
          zip_code: formValues?.zip_code || ''
        }
        nonce = encryptionHandler(cardData)
      }

      const payloadBeforePayemnt = {
        'citation_number': facilityData?.ticket?.citation_number,
        'name': formValues?.name_on_card,
        'email': formValues?.email,
        'phone': formValues?.phone,
        'nonce': nonce
      }

      try {
        const recaptchaToken = await captchaService.execute('checkout')
        payloadBeforePayemnt.recaptcha_token = recaptchaToken
      } catch (captchaError) {
        setIsSubmitted(false)
        notify('error', captchaError?.message || 'reCAPTCHA verification could not be completed.')
        return
      }

      dispatch(postBeforePayment(payloadBeforePayemnt)).then((res) => {
        if (res?.status === 201) {
          setIsSubmitted(false)
          const responseData = res?.data
          handleGetForData()
          localStorage.setItem('paymentResponse', JSON.stringify(responseData))
          if (responseData) {
            navigate(`/${partner}/paymentResponse/${citation}`)
          }
        } else {
          setIsSubmitted(false)
          notify('error', res?.errors?.message)
        }
      }).catch((err) => {
        setIsSubmitted(false)
        notify('error', err)
      })
    } else {
      if (iframeErrorMsg && iframeErrorMsg != '') {
        notify('error', iframeErrorMsg)
      }
    }
  }

  // CREATE APPEAL REQUEST 
  const handleCreateAppealVoid = (formValues) => {
    if (!isAppealRequest) {
      if (showAppealModal) {
        const payload = {
          'citation_id': (facilityData?.ticket?.id) ? facilityData?.ticket?.id : '',
          'partner_id': (facilityData?.ticket?.partner_id) ? facilityData?.ticket?.partner_id : '',
          'facility_id': (facilityData?.facility?.id) ? facilityData?.facility?.id : '',
          'user_remark': formValues?.remarks,
          'appealed_by': (facilityData?.ticket?.user_id) ? facilityData?.ticket?.user_id : '',
          'appeal_status': '1',
          'user_email': formValues?.email || ''
        }
        setIsAppealRequest(true)
        dispatch(postCreateAppeal(payload)).then((res) => {
          if (res?.status === 201) {
            setIsAppealRequest(false)
            handleShowAppealModal()
            notify('success', res?.data?.msg)
            navigate(0)
          } else {
            setIsAppealRequest(false)
            notify('error', res?.errors?.message)
          }
        }).catch((err) => {
          setIsAppealRequest(false)
          notify('error', err)
        })
      } else {
        const payload = {
          id: (facilityData?.ticket?.id) ? facilityData?.ticket?.id : '',
          avoid_comment: formValues.remarks,
          is_avoid: '2'
        }
        setIsAppealRequest(true)
        dispatch(postVoidAppeal(payload)).then((res) => {
          if (res?.status === 201) {
            setIsAppealRequest(false)
            handleVoidModal()
            notify('success', res?.data?.msg)
            navigate(0)
          } else {
            setIsAppealRequest(false)
            notify('error', res?.errors?.message)
          }
          setIsAppealRequest(false)
        }).catch((err) => {
          setIsAppealRequest(false)
          notify('error', err)
        })
      }
    }
  }

  const onSubmitAppealVoid = handleSubmitForm2(handleCreateAppealVoid)

  const [isLightboxOpen, setIsLightboxOpen] = useState(false)
  const [currentImage, setCurrentImage] = useState(null)

  const handleImageClick = (image) => {
    setCurrentImage(image)
    setIsLightboxOpen(true)
  }

  const closeLightbox = () => {
    setIsLightboxOpen(false)
    setCurrentImage(null)
  }
  const handlCardExpiry = (value) => {
    setCardExpiry(value)
    // let expiryDateCheck = validExpiryDate(value)
    // if (value.length == 4 && !expiryDateCheck) {
    //   setCardExpiryMessage('Enter a valid expire date')
    // } else {
    //   setCardExpiryMessage('')
    // }
  }

  return (
    <>
      <div className="contaienr-fulid">
        <section className="citation-section d-flex flex-column gap-3 mt-60 ">
          <div className='mx-auto d-block'>
            <span className='bg-danger p-3 d-flex icon align-items-center justify-content-center text-white'><img height="50px" src={corssImg} /></span>
          </div>

          <h4 className="text-center text-secondary fw-bold mt-3">{facilityData?.facility?.full_name}</h4>
          <div className='bg-light rounded py-2 text-center'>
            <p className="text-center small mb-0"><small>Parking Violation</small></p>
            <h2 className="text-uppercase">{(checkStartCitationWarning(citation) == 'WA') ? `Warning - ${citation}` : (checkStartCitationWarning(citation) == 'CI') ? `Citation - ${citation}` : ''}</h2>
          </div>

          <div className='row g-2 row-cols-3 justify-content-center'>
            <div className='col'>
              {(facilityData?.ticket?.license_plate_image_url && facilityData?.ticket?.license_plate_image) ?
                <div className="w-100 m-auto d-flex gap-2 align-items-center justify-content-center">
                  <a className="rounded  bg-light p-1" onClick={() => handleImageClick(facilityData?.ticket?.license_plate_image_url)} ><img src={facilityData?.ticket?.license_plate_image_url} style={{ maxHeight: '60px', cursor: 'pointer' }} /></a>
                </div> : ''}
            </div>

            {(facilityData?.ticket?.ticket_citation_image && facilityData?.ticket?.ticket_citation_image.length > 0) ?
              facilityData?.ticket?.ticket_citation_image?.map((item, index) => {
                return <div className='col' key={index}>
                  <div className="w-100 m-auto d-flex gap-2 align-items-center justify-content-center">
                    <a className="rounded bg-light p-1" onClick={() => handleImageClick(item?.image_url)}><img src={item?.image_url} style={{ maxHeight: '60px', cursor: 'pointer' }} /></a>
                  </div>
                </div>
              }) : ''}
          </div>

          <div className='p-2'>
            {/* citation Data Table */}
            <table className={'table-sm table table-borderless'}>
              <tbody>
                {loader ? <div className='d-flex justify-content-center align-items-center'> <Circles
                  height="50"
                  width="50"
                  style={{ display: 'inline-block' }}
                  color="var(--bs-primary)"
                  ariaLabel="circles-loading"
                  visible={true}
                /></div> : citationData?.length > 0 && (!loader) ? citationData?.map((getCitionDataItem, getCitionDataIndex) => {
                  return (
                    <tr key={getCitionDataIndex}>
                      <td className='small' > {getCitionDataItem?.headerName}</td>
                      <td className='small text-end fw-bold text-secondary' >
                        {getCitionDataItem?.id === 0 ? `$${getFormattedAmountNumber(getCitionDataItem?.val)}` : getCitionDataItem?.val}</td>
                    </tr>
                  )
                }) : (citation === undefined || citation === null || citation === '' || error === '') && citationData?.length === 0 && (!loader) ?
                  <div>
                    <p className="text-danger header-s text-center fw-bold">Something Went Wrong</p>
                    <p className="text-danger header-s text-center fw-bold">Unable to Fetch Faclity , Please Try Again!</p>
                  </div>
                  : (error !== '') ? <p className="text-danger header-s text-center fw-bold">{error}</p> : ''}
              </tbody>
            </table>
          </div>
        </section>

        {(appealDataForTable?.length > 0) && <section className='citation-section d-flex flex-column gap-3 mt-0'>
          <div className='p-2'>
            {!(loader) ? (

              <>
                {appealDataForTable?.length > 0 && appealDataForTable?.map((exsitingAppealItem, exsitingAppealIndex) => {
                  return (
                    <table key={exsitingAppealIndex} className={`table-sm table table-borderless ${exsitingAppealItem?.appeal == 'Appeal 1' ? 'mb-3' : ''} `}>
                      <tbody   >
                        <React.Fragment>
                          <tr className='border-bottomDasshed' >
                            <td colSpan={2}>
                              <span className='fw-bold '>{exsitingAppealItem?.appeal}</span>
                            </td>
                          </tr>

                          {exsitingAppealItem?.data?.map((appealDetail, detailIndex) => (
                            <tr key={detailIndex}>
                              <td className={nullAndUndefinedCheck(appealDetail?.isHighlight) ? 'fw-bold text-uppercase text-primary' : 'small'} >{appealDetail?.headerName}</td>
                              <td className={nullAndUndefinedCheck(appealDetail?.isHighlight) ? 'small text-end text-uppercase fw-bold text-primary' : 'small text-end fw-bold text-secondary'} > {appealDetail?.id === 0 ? `$${appealDetail?.val}` : appealDetail?.val} </td>
                            </tr>
                          ))}
                        </React.Fragment>
                      </tbody>
                    </table>
                  )
                })}
              </>
            ) : null}
          </div>
        </section>}

        {showPaymentCardDetials(citationData, facilityData, loader, citation, appealAppliedData) ? <section className="my-3 p-3 pt-1">
          <div className="d-grid gap-2 col-12 mx-auto">
            {/* <Form onSubmit={handleSubmit(onSubmit)} control={control} action={url} ref={formRef} id='ipg_form' target="_top" name='ipg_form' method='post'> */}
            <Form onSubmit={handleSubmit(onSubmit)} control={control} ref={formRef} id='ipg_form' target="_top" name='ipg_form' method='post'>
              {/* phone */}
              <h6 className="pay_by_card text-left w-100 fw-bold m-0 mt-3  ">Enter Personal Details</h6>

              <div className="input-group mt-3">
                <Controller
                  name="phone"
                  type="text"
                  id="phone"
                  control={control}
                  autoComplete="tel"
                  defaultValue=''
                  rules={{ required: true, minLength: { value: 10, message: 'Please enter a valid number' }, maxLength: 10 }}
                  render={({ field }) => <MaskedInput
                    maskGenerator={phoneMaskGenerator}
                    className="form-control"
                    {...field}
                    maxLength={14}
                    title="Please enter a valid phone number"
                    onInvalid={e => e.target.setCustomValidity('Please enter phone number')}
                    onInput={e => e.target.setCustomValidity('')}
                    placeholder="Enter Your Phone"
                    disabled={(citation === undefined || citation === null || citation === '') ? true : false}
                  />
                  }
                />
              </div>
              {errors?.phone?.type === 'required' && <Form.Text className="text-danger header-s">This field is required</Form.Text>}
              {errors?.phone?.type === 'minLength' && <Form.Text className="text-danger header-s">{errors?.phone?.message}</Form.Text>}

              {/* email */}
              <div className="input-group mt-3">
                <input type="email" name='email' autoComplete="email" onKeyPress={(e) => { handleKeyPressRestrictLeadingTrailingSpace(e) }} className="form-control" maxLength='40' minLength='1' placeholder="Enter your email"{...register('email', {
                  required: true,
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: 'invalid email address'
                  }
                })} disabled={(citation === undefined || citation === null || citation === '') ? true : false} />
              </div>
              {errors?.email?.type === 'required' && <Form.Text className="text-danger header-s">This field is required</Form.Text>}
              {errors?.email?.type === 'pattern' && <Form.Text className="text-danger header-s">{errors?.email?.message}</Form.Text>}

              <h6 className="pay_by_card text-left w-100 fw-bold m-0 mt-3">Enter Card Details</h6>
              {facilityData?.facility?.facilty_payment_detail?.facility_payment_type_id != '3' ?
                <>
                  {/* name on card */}
                  <div className="input-group mt-3">
                    <input
                      autoComplete="cc-name"
                      name='name_on_card'
                      className="form-control "
                      maxLength={20}
                      minLength={1}
                      placeholder="Name on Card"
                      type="text"
                      onKeyPress={(e) => { handleKeyPressRestrictLeadingTrailingSpace(e) }}
                      {...register('name_on_card', { required: true })}
                      disabled={(citation === undefined || citation === null || citation === '') ? true : false}
                    />
                  </div>
                  {errors?.name_on_card && <Form.Text className="text-danger header-s">This field is required</Form.Text>}

                  {/* card_number */}
                  <div className="input-group mt-3">
                    <Controller
                      name="card_pan"
                      type="text"
                      id="card_pan"
                      control={control}
                      rules={{ required: true, maxLength: 19 }}
                      render={({ field }) => <MaskedInput
                        maskGenerator={cardnumbermask}
                        autoComplete="cc-number"
                        pattern="[0-9 ]{18,19}"
                        maxLength='19'
                        {...field}
                        title="Card no. should be 15-16 digit numberic"
                        className="form-control"
                        onInvalid={e => e.target.setCustomValidity('Please enter a valid card number')}
                        onInput={e => e.target.setCustomValidity('')}
                        placeholder="Credit Card Number"
                        disabled={(citation === undefined || citation === null || citation === '') ? true : false}
                      />}
                    />
                  </div>
                  {errors?.card_pan?.type === 'required' && <Form.Text className="text-danger header-s">This field is required</Form.Text>}

                  {/* expiration_date and cvv */}

                  <div className="row g-2 mt-2 ">
                    <div className="col-sm-4 col-4">
                      <Controller
                        name="expiry"
                        type="text"
                        inputMode="numeric"
                        id="expiry"
                        control={control}
                        rules={{
                          // pattern: { value: /^(0[1-9]|1[0-2])\d{2}$/, message: 'Please enter a valid date' },
                          required: { value: true, message: 'This field is required' },
                          minLength: { value: 4, message: 'Please enter a valid date' },
                          maxLength: { value: 5, message: 'Please enter a valid date' },
                          validate: (value) => {
                            let valid = validExpiryDate(value)
                            if (!valid) {
                              return 'Please enter a valid date'
                            }
                          },
                        }}

                        render={({ field }) => <span className='cardNumberCardImage'> <MaskedInput
                          maskGenerator={expirymask}
                          autoComplete="cc-exp"
                          // pattern='/^(0[1-9]|1[0-2])\d{2}$/'
                          // pattern="[0-9 ]{4}"
                          maxLength='5'
                          {...field}
                          inputMode="numeric"
                          onChange={(e) => { field.onChange(e); handlCardExpiry(e) }}
                          value={cardExpiry}
                          id="expiry"
                          // title="Enter a valid Expiry Date in MM/YY format"
                          className="form-control"
                          // onInvalid={e => e.target.setCustomValidity('Please enter a valid expiry date')}
                          // onInput={e => e.target.setCustomValidity('')}
                          placeholder="MM/YY"
                        /></span>}
                      />
                      {errors?.expiry && <Form.Text className="text-danger header-s">{errors?.expiry?.message}</Form.Text>}
                      {/* {<Form.Text className="text-danger header-s">{cardExpiryMessage}</Form.Text>} */}
                    </div>
                    <div className="col-sm-4 col-4">
                      <input
                        autoComplete="cc-csc"
                        className="form-control"
                        id="standardCardCvv"
                        maxLength="4"
                        name="security_code"
                        placeholder="CVV"
                        type="password"
                        {...register('security_code', { required: true })}
                        disabled={(citation === undefined || citation === null || citation === '') ? true : false}
                      />
                      {errors?.security_code?.type === 'required' && <Form.Text className="text-danger header-s">This field is required</Form.Text>}

                    </div>
                    <div className="col-sm-4 col-4">
                      {/* zipcode */}
                      <div className="input-group ">
                        <input
                          className="form-control "
                          maxLength="6"
                          minLength="5"
                          name="zip_code"
                          placeholder="Zip Code"
                          type="text"
                          {...register('zip_code', { maxLength: 6, minLength: 5 })}
                          disabled={(citation === undefined || citation === null || citation === '') ? true : false}
                          onPaste={(e) => {
                            e.preventDefault()
                            return false
                          }}
                          onKeyPress={(e) => (isPermissionExist('Restricted Permissions', 'Allow AlfaNumericZipcode')) ? restrictSpecialChar(e) : restrictInputValues(e)}
                        />
                      </div>
                      <small><span className='text-danger small'>**Mandatory for Amex Cards only</span></small>
                      {['maxLength', 'minLength', 'pattern'].includes(errors?.zip_code?.type) && <Form.Text className="text-danger header-s">Please use valid Zip Code</Form.Text>}
                    </div>
                  </div>

                  <input type='hidden' name='XXX_IPG_XXX' id='XXX_IPG_XXX' value='confirm' />
                  <input type='hidden' name='XXX_IPGTRXNO_XXX' id='XXX_IPGTRXNO_XXX' value={guid} />
                  <input type='hidden' name='XXX_IPGSESSION_XXX' id='XXX_IPGSESSION_XXX' value={ipgSession}></input>
                  {/* Submit Button */}
                </>
                :
                <CardConnectTokenizer
                  setToken={setCardToken}
                  faciltyPaymentDetails={facilityData?.facility?.facilty_payment_detail}
                  setIframeErrorMessage={setIframeErrorMsg}
                  tokenRef={tokenRef}
                />
              }
              <div className="mt-3">
                <button type="submit" className="btn mt-2 w-100 text-white bg-primary" disabled={(!isValid || citation === undefined || citation === null || citation === '' || isSubmitted || (facilityData?.ticket?.is_avoid == 1) || (facilityData?.ticket?.is_closed == 1)) ? true : false} > <div className='d-flex justify-content-center align-items-center'>
                  <span>Proceed </span>  <span className='ms-2'>
                    {(loader || isSubmitted) ? <Circles
                      height="20"
                      width="20"
                      style={{ display: 'inline-block' }}
                      color="#ffffff"
                      ariaLabel="circles-loading"
                      visible={true}
                    /> : null}
                  </span>
                </div>
                </button>
              </div>
            </Form>
          </div>
          {(showButtionForAppealVoid) ? <div className='d-flex gap-2'>
            {(isPermissionExist('Restricted Permissions', 'Citation Appeal')) ? <button type="button" className="btn mt-2 w-100 btn-dark text-white"
              disabled={(citation === undefined || citation === null || citation === '' || isSubmitted || isAppealRequest || (facilityData?.ticket?.is_avoid == 1) || (facilityData?.ticket?.is_closed == 1)) ? true : false}
              onClick={() => handleShowAppealModal()}>Appeal</button> : null}
            {(isPermissionExist('Restricted Permissions', 'Citation Void') && isVoidButton()) ? <button type="button" className="btn mt-2 w-100 text-white btn-danger"
              disabled={(citation === undefined || citation === null || citation === '' || isSubmitted || isAppealRequest || (facilityData?.ticket?.is_avoid == 1) || (facilityData?.ticket?.is_closed == 1)) ? true : false}
              onClick={() => handleVoidModal()}>Void</button> : null}
          </div> : null}
        </section> : (facilityData?.citation_history?.[0]?.citation_status == 'Expired') ?
          <section className="m-3 d-block"><div className="bg-white aling-items-center  shadow-lg d-flex flex-column gap-3 rounded-5 p-4">
            <h6 className="text-center">{facilityData?.ticket.expired_msg}</h6>
            <span className="text-center">
              <a href={(facilityData?.ticket?.expired_payment_link) ? facilityData?.ticket?.expired_payment_link : ''} className='btn btn-primary' role='button'>Click Here!</a>
            </span>
          </div>
          </section> : null}

        <Form onSubmit={handleSubmitForm2(handleCreateAppealVoid)} control={controlForm2} ref={formRef2} id='ipg_form2' target="_top" name='ipg_form2' method='post'>
          <AppealModal
            showAppealModal={showAppealModal}
            handleShowAppealModal={handleShowAppealModal}
            ModalHeader='Appeal'
            citation={citation}
            isAppealRequest={isAppealRequest}
            onSubmitAppealVoid={onSubmitAppealVoid}
            appealData={nullAndUndefinedCheck(facilityData?.ticket) && nullAndUndefinedCheck(facilityData?.ticket?.appeal) && Object.keys(facilityData?.ticket?.appeal).length > 0 ? facilityData?.ticket?.appeal : EMPTY_OBJECT}
            errors={errorsForm2}
            control={controlForm2}
            is_void_exist={facilityData?.ticket?.is_avoid == 1}
            is_closed_exist={facilityData?.ticket?.is_closed == 1}
            setErrorForm2={setErrorForm2}
          />

          <AppealModal
            showAppealModal={showVoidModal}
            handleShowAppealModal={handleVoidModal}
            ModalHeader='Void Citation'
            citation={citation}
            isAppealRequest={isAppealRequest}
            onSubmitAppealVoid={onSubmitAppealVoid}
            appealData={EMPTY_OBJECT}
            errors={errorsForm2}
            control={controlForm2}
            is_void_exist={facilityData?.ticket?.is_avoid == 1}
            is_closed_exist={facilityData?.ticket?.is_closed == 1}
            voidRemarks={nullAndUndefinedCheck(facilityData?.ticket?.avoid_comment) ? facilityData?.ticket?.avoid_comment : ''}
            setErrorForm2={setErrorForm2}
          />
        </Form>
      </div>

      {/* Lightbox */}
      {isLightboxOpen && (
        <div className="lightbox" onClick={closeLightbox}>
          <div className="lightbox-content d-flex gap-3 flex-column align-items-center justify-content-center">
            <img src={currentImage} alt="Full View" />
            <button className="btn btn-danger" onClick={closeLightbox}>
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      )}
    </>
  )
}

Main.propTypes = {
  dispatch: PropTypes.func,
  loader: PropTypes.bool,
  notify: PropTypes.func,
  partnerDetails: PropTypes.object,
}

Main.defaulProps = {
  dispatch: noop,
  loader: false,
  notify: noop,
  partnerDetails: {}
}

function mapStateToProps({ citationReducer }) {
  return {
    loader: citationReducer?.loader,
  }
}
export default connect(mapStateToProps)(Main)